import { findOptimalPositions, type Letters } from '@/domain/scoring';
import styles from './HiWord.module.css';

const DEFAULT_LETTERS: Letters = ['к', 'о', 'т'];

interface HiWordProps {
  word: string;
  letters?: Letters;
  size?: 'sm' | 'md' | 'lg';
}

export function HiWord({ word, letters = DEFAULT_LETTERS, size }: HiWordProps) {
  const normalized = word.toLowerCase().replace(/-/g, '').replace(/ё/g, 'е');
  const [a, b, c] = letters;
  const normLetters: Letters = [
    a === 'ё' ? 'е' : a,
    b === 'ё' ? 'е' : b,
    c === 'ё' ? 'е' : c,
  ];
  const pos = findOptimalPositions(normalized, normLetters);

  const cls = [styles.word, size && styles[size]].filter(Boolean).join(' ');

  return (
    <span className={cls}>
      {normalized.split('').map((ch, i) => {
        if (pos && i === pos.l1) return <span key={i} className={styles.l1}>{ch}</span>;
        if (pos && i === pos.l2) return <span key={i} className={styles.l2}>{ch}</span>;
        if (pos && i === pos.l3) return <span key={i} className={styles.l3}>{ch}</span>;
        return ch;
      })}
    </span>
  );
}
